import CryptoJS from 'crypto-js';
import moment from 'moment';
import security from '../config/security';

export const urlParams = (apiEndpoint, securityKey = '') => {
  if (!security[securityKey]) {
    return '';
  }

  const apiKey = security[securityKey].apiKey;
  const secretKey = security[securityKey].secretKey;

  const time = moment().format('YYYY-MM-DDTHH:mm:ssZ');

  const stringToSign = apiEndpoint + '\n' + time;
  const signature =
    CryptoJS.enc.Base64.stringify(
      CryptoJS.HmacSHA256(stringToSign, secretKey));

  return `key=${encodeURIComponent(apiKey)}&dateTime=${encodeURIComponent(time)}&signature=${encodeURIComponent(
    signature)}`;
};

export const securityHeaders = () => {
  return {};
};



// WEBPACK FOOTER //
// ./src/utils/security_utils.js